import React from 'react';
import styles from './ApplicableFeeDetails.scss';

const ApplicableFeeDetails = () => (
    <p className={styles.applicableFeeDetails}>Different unit types available.
        Detailed fees will appear when you choose a unit type.
    </p>
);

export default ApplicableFeeDetails;
